import i18n from 'utils/i18n'
import type { TableFiltersConfig } from 'components/Common/Table/Layout/Page/_methods/types'
import {
  filterTypes,
  SWITCHER,
  ADMIN_FILTERS_KEY,
  ADMIN_FILTERS_TITLE,
  ADMIN_FILTERS_NAME,
} from 'utils/consts'
import { getAdministrationMentionsFiltersCollection } from 'utils/filtersCollections/administration/mentions'

export const getAdministrationLinkMentionsFiltersCollection = () => [
  ...getAdministrationMentionsFiltersCollection(),
  {
    type: filterTypes[SWITCHER],
    title: i18n.t(ADMIN_FILTERS_TITLE.isPrivilegedFilter),
    filterName: ADMIN_FILTERS_NAME.isPrivilegedFilter,
    apiFilterName: ADMIN_FILTERS_KEY.isPrivilegedFilter,
  },
]

export const adminLinkMentionsFiltersConfig: TableFiltersConfig = {
  getFiltersCollection: getAdministrationLinkMentionsFiltersCollection,
  pathToStore: [],
  filtersDataPath: ['admin', 'mentions', 'mentionsFilters'],
  showResultsTextKey: 'filters.button.apply',
}
